import { GLYPH_HEIGHT } from 'maplestory-glyph-decoder';
export function assertCanonicalOwlTarget(target) {
    if (target.image.height !== GLYPH_HEIGHT) {
        throw new RangeError(`Owl target ${target.key} must be a canonical ${GLYPH_HEIGHT}px-high glyph-line crop`);
    }
}
//# sourceMappingURL=canonical.js.map